import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {Category} from '@spartacus/core';
import {CustomCategoryAdapter} from './custom-category.adapters';


@Injectable({
  providedIn: 'root',
})
export class CustomCategoryConnector {
  constructor(protected adapter: CustomCategoryAdapter) {}

  get(code): Observable<Category> {
    return this.adapter.load(code);
  }
}
